import { slugify } from '../../../../../utils/slugify';

const getRichTextHeadingId = children => {
  if (!children || !children[0]) return '';

  const firstChild = children[0];
  const content = typeof firstChild === 'string' ? firstChild : firstChild?.props?.children;

  return content ? slugify(content) : '';
};

export default getRichTextHeadingId;
